/* eslint-env browser, jquery */
import page from 'modules/ab-page-js';
import domify from 'domify';
import highlightjs from 'highlightjs';
import metrics from 'modules/metrics';
import container from 'modules/section-content';
import ContactForm from 'auth0-contact-form';
import Batch from 'batch';
import rg from 'modules/npm-component/require-global';
import React from 'react';
import abTesting from 'modules/ab-testing';
import { render, unmountComponentAtNode } from 'react-dom';
import { OnboardingFlow, PricingPlans, Auth0Animation } from 'components';
import PricingScripts from 'components/pricingPlans/vendor/index';
import layout from './home-page.pug';
import metadata from './data/metadata.json';
import lottie from 'lottie-web';
import slackNotificationRule from './rule-templates/slack-notification.js.txt';
import onlyAllowWeekdatsRule from './rule-templates/only-allow-weekdays.js.txt';
import ipWhitelistRule from './rule-templates/ip-whitelist.js.txt';
import emailVerifiedRule from './rule-templates/email-verified.js.txt';
import guardianMultifactorChangedLocationRule from './rule-templates/guardian-multifactor-changed-location.js.txt';
import intercomUserRule from './rule-templates/intercom-user.js.txt';
import linkUserByEmailRule from './rule-templates/link-users-by-email.js.txt';
import mongodbRule from './rule-templates/mongodb.js.txt';
import sendEventsSegmentioRule from './rule-templates/send-events-segmentio.js.txt';
import sendgridRule from './rule-templates/sendgrid.js.txt';
import splunkTrackEventRule from './rule-templates/splunk-track-event.js.txt';
import 'slick-carousel';

const pricingScripts = new PricingScripts();

// let unmountLockHeroDemo = () => {};
let unmountOnboardingFlow = () => {};
let unmountAuth0Animation = () => {};
/**
 * Routes
 */
export default function register() {
  page(
    '/',
    initial,
    loadScripts,
    renderPricingPlans,
    pricingScripts.loadScripts,
    pricingScripts.renderPricing,
    pricingScripts.renderFeatures,
    pricingScripts.snippets,
    snippets
  );
  page.exit('/', exit);
  page.exit('/signup', exit);
}

/**
 * Handle server-side and client-side render differently
 */
function initial(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(layout({ rule: slackNotificationRule })) })
  };
  container.render(renderOptions);

  return next();
}

function renderPricingPlans(ctx, next) {
  const $ = window.$;

  abTesting.executeExperiment('home-show-pricing-plans', variant => {
    if (variant && variant.name === 'show-pricing-plans') {
      $('.try-auth0').remove();
      return renderReactComponent(
        <PricingPlans />,
        document.querySelector('.solution-page-pricing-plans')
      );
    }
  });

  return next();
}

function loadScripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/homepage/vendor/jquery-mobile-74ee4c679b.min.js', '$.fn.swiperight', done);
  });

  batch.push(done => {
    rg('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.end(next);
}

/**
 * Snippets
 */
function snippets(ctx, next) {
  const $ = window.$;

  // unmountLockHeroDemo = renderLockHeroDemo();
  unmountOnboardingFlow = renderOnboardingFlow();
  unmountAuth0Animation = renderAuth0Animation();

  popoverEmbedWistia();

  const carouselControls = $('[data-slide="prev"], [data-slide="next"], [data-slide-to]');

  // Load Roboto Mono Font
  loadRobotoFont();

  // Highlightjs

  highlightjs.configure({
    classPrefix: '',
    languages: ['javascript']
  });

  $('pre code').each((i, block) => {
    highlightjs.highlightBlock(block);
  });

  // rulesDemoAnimation();

  // Add css animation
  $('.carousel').bind('slide.bs.carousel', () => {
    $('.slides').addClass('animated');
  });

  // Track scroll until the widget is reached, then fire metrics event and unbind scroll
  $(window).on('scroll', trackScrollHomepage);

  // Track when carousel controls are clicked
  carouselControls.on('click', () => {
    metrics.lib().track('click:carousel');
  });

  $('#carousel').swiperight(function swiperight() {
    $(this).carousel('prev');
  });
  $('#carousel').swipeleft(function swipeleft() {
    $(this).carousel('next');
  });

  const wow = new WOW();
  wow.init();

  contactFormModals();

  startMobileCarousel();

  next();
}

/**
 * Render lock hero demo
 */
// function renderLockHeroDemo() {
//   return renderReactComponent(<LockHomeDemo />, document.getElementById('hero-lock-demo'));
// }

/**
 * Render Onboarding Flow
 */
function renderOnboardingFlow() {
  return renderReactComponent(
    <OnboardingFlow />,
    document.getElementById('onboarding-flow-container')
  );
}

/**
 * Render Auth0 animation
 */
function renderAuth0Animation() {
  return renderReactComponent(
    <Auth0Animation />,
    document.getElementById('js-auth0-animation-container')
  );
}

function renderReactComponent(instance, element) {
  let rendered = false;

  render(instance, element, setRenderedTrue);

  return unmounReactComponent;

  function setRenderedTrue() {
    rendered = true;
  }

  function unmounReactComponent() {
    if (rendered) {
      unmountComponentAtNode(element);
    }
  }
}

/**
 *  load popover embeds wistia Video
 */
function popoverEmbedWistia() {
  const popoverOptions =
    'autoPlay=true&controlsVisibleOnLoad=true&popover=true&version=v1&videoHeight=360&videoWidth=640';
  const hrefValue = `//fast.wistia.com/embed/iframe/fu7ww3h1yx?${popoverOptions}`;
  const addAttr = () => {
    $('#wistia-popover').on('click', false);
    return $('.video-btn').attr('href', hrefValue);
  };

  $.when(addAttr()).done(() => {
    $.getScript('//fast.wistia.com/static/popover-v1.js');
  });
}

/**
 * Set carousel height
 */
function setCarouselHeight() {
  const $ = window.$;
  const windowHeight = $(window).height();
  const headerHeight = $('.site-header-v2').outerHeight(true);
  const customersHeight = $('.customers').outerHeight();
  $('.carousel').height(windowHeight - headerHeight - customersHeight);
}

/**
 * Load Roboto font
 */
function loadRobotoFont() {
  window.WebFontConfig = {
    google: { families: ['Roboto+Mono:400:latin'] }
  };
  (function webfont() {
    const wf = document.createElement('script');
    const s = document.getElementsByTagName('script')[0];
    wf.src = `${document.location.protocol === 'https:'
      ? 'https'
      : 'http'}://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js`;
    wf.type = 'text/javascript';
    wf.async = 'true';
    s.parentNode.insertBefore(wf, s);
  })();
}

/**
 * Track scroll on homepage when widget is reached
 */
let trackScrollDown = true;

function trackScrollHomepage() {
  const $ = window.$;
  let widgetOffsetTop = 0;
  if ($('#onboarding-flow-container').length) {
    widgetOffsetTop = $('#onboarding-flow-container').parent().parent().offset().top;
  }

  let rulesOffset = 0;

  let rulesHeight = 0;
  if ($('.extensibility-example').length) {
    rulesOffset = $('.extensibility-example').parent().parent().offset().top;
    rulesHeight = $('.extensibility-example').outerHeight(true);
  }

  if ($(window).scrollTop() >= widgetOffsetTop && trackScrollDown) {
    metrics.lib().track('scroll:homepage');
    trackScrollDown = !trackScrollDown;
  }

  if ($(window).scrollTop() < widgetOffsetTop && !trackScrollDown) {
    trackScrollDown = !trackScrollDown;
  }

  if ($(window).scrollTop() >= rulesOffset && $(window).scrollTop() <= rulesOffset + rulesHeight) {
    $('.rules-animation').addClass('is-active');
  } else {
    $('.rules-animation').removeClass('is-active');
  }
}

/**
 *  // Contact Sales Form
 */
function contactFormModals() {
  const salesContactFormOptions = {
    onModalOpen() {
      window.metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      window.metricsLib.track('register:lead:homepage-contact-form', metricsData);
      if (window.mouseFlow) window.mouseFlow.formSubmitSuccess('#contact-form-modal__form');
    },
    onFormFail(metricsData) {
      window.metricsLib.track('fail:register:lead:homepage-contact-form', metricsData);
      if (window.mouseFlow) window.mouseFlow.formSubmitFailure('#contact-form-modal__form');
    },
    source: 'home-page'
  };
  const salesContactForm = new ContactForm(salesContactFormOptions);

  $('.open-contact-form-modal').click(() => salesContactForm.show({ includePhoneField: true }));
}

/**
 * Unsubscribe from window events
 */
function exit(ctx, next) {
  const $ = window.$;
  $(window).off('scroll', trackScrollHomepage);
  $(window).off('resize', setCarouselHeight);

  unmountComponentAtNode(document.querySelector('.solution-page-pricing-plans'));
  // unmountLockHeroDemo();
  unmountOnboardingFlow();

  next();
}

/**
 * Update carousel
 */
function startMobileCarousel() {
  $('.mobile-slider').slick({
    arrows: false,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    dots: true,
    swipe: false,
    appendDots: $('.bottom-nav-wrapper'),
    customPaging: function(slider, i) {
      return '<button></button>';
    }
  });
}

/**
 * show animation a/b - experiments
 */

window.animationExperiment = () => {
  const $ = window.$;
  const vid = document.getElementById('why-video');

  function playVid() {
    vid.play();
  }

  $('a.play-me-again').on('click', e => {
    e.preventDefault();

    if (window.wistiaJQuery) playVid();
  });
};

/* Select */

const ruleTemplates = {};

ruleTemplates.option1 = slackNotificationRule;
ruleTemplates.option2 = onlyAllowWeekdatsRule;
ruleTemplates.option3 = ipWhitelistRule;
ruleTemplates.option4 = emailVerifiedRule;
ruleTemplates.option5 = guardianMultifactorChangedLocationRule;
ruleTemplates.option6 = intercomUserRule;
ruleTemplates.option7 = linkUserByEmailRule;
ruleTemplates.option8 = mongodbRule;
ruleTemplates.option9 = sendEventsSegmentioRule;
ruleTemplates.option10 = sendgridRule;
ruleTemplates.option11 = splunkTrackEventRule;

function rulesDemoAnimation() {
  $('#ruleOptions').change(function rulesDemoAnimationOnChange() {
    const selected = $(this).val();

    $('.rule-editor pre code').empty();

    $('.rule-editor pre code').append(ruleTemplates[selected]);

    $('pre code').each((i, block) => {
      highlightjs.highlightBlock(block);
    });
  });
}



// WEBPACK FOOTER //
// ./src/pages/homepage/client.js